import _extends from"@babel/runtime/helpers/extends";import React from'react';
import{useTranslation}from'react-i18next';
import'@adyen/adyen-web/dist/adyen.css';
import'react-loading-skeleton/dist/skeleton.css';

import App from"../app";

var footerIcons=[
{
font:'fontAwesome',
name:'instagram',
href:'https://www.instagram.com/mola.sport/'
},
{
font:'fontAwesome',
name:'facebook',
href:'https://www.facebook.com/molatv.sport'
},
{
font:'fontAwesome',
name:'youtube',
href:'https://www.youtube.com/@MOLA_TV'
},
{
font:'fontAwesome',
name:'tiktok',
href:'https://www.tiktok.com/@mola.sport?_t=8eTItZbUQrK&_r=1'
},
{
font:'fontAwesome',
name:'envelope',
href:'mailto:support@mola.tv'
}];


var WebApp=function WebApp(props){
var _useTranslation=useTranslation(['mol']),t=_useTranslation.t;

var footerLinks=[
{title:t('footer.contactUs'),href:'https://www.24i.com/contact/'},
{title:t('footer.news'),href:'https://www.24i.com/articles/'}];


return React.createElement(App,_extends({footerLinks:footerLinks,footerIcons:footerIcons},props));
};

export default WebApp;